import { ListHeaderWithColumns } from "../AppListHeader/ListHeaderWithColumns";
import { AppListItemShimmer } from "../AppListItem/AppListItemShimmer/AppListItemShimmer";
import { FeatureListItem } from "../FeatureListItem/FeatureListItem";
import { LimitListItemShimmer } from "../LimitListItemShimmer/LimitListItemShimmer";
import { ListContentWithDetails } from "../ListContentWithDetails/ListContentWithDetails";
import { PillContainerListItem } from "../Pill/PillContainerListItem/PillContainerListItem";

export const validFamilyListItemComponents: readonly React.ComponentType<any>[] = [
    AppListItemShimmer,
    FeatureListItem,
    ListContentWithDetails,
    ListHeaderWithColumns,
    LimitListItemShimmer,
    PillContainerListItem
];
